import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WifiTetheringOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_tethering_off"}/>
}
